var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreationThumbnailVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 81,
    viewBox: "0 0 58 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11741",
    "data-name": "Group 11741",
    transform: "translate(-878.5 -2069.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4876",
    "data-name": "Rectangle 4876",
    width: 81,
    height: 58,
    transform: "translate(878.5 2150.5) rotate(-90)",
    fill: "#e5e6eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-image",
    "data-name": "Icon feather-image",
    transform: "translate(889.5 2092.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12033",
    "data-name": "Path 12033",
    d: "M7.5,4.5h21a3,3,0,0,1,3,3v21a3,3,0,0,1-3,3H7.5a3,3,0,0,1-3-3V7.5a3,3,0,0,1,3-3Z",
    fill: "none",
    stroke: "#9fa2a5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12034",
    "data-name": "Path 12034",
    d: "M15,12.75a2.25,2.25,0,1,1-2.25-2.25A2.25,2.25,0,0,1,15,12.75Z",
    fill: "none",
    stroke: "#9fa2a5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12035",
    "data-name": "Path 12035",
    d: "M31.5,22.5,24,15,7.5,31.5",
    fill: "none",
    stroke: "#9fa2a5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreationThumbnailVertical);
export default __webpack_public_path__ + "static/media/creation-thumbnail-vertical.8e83a9c5b9dbfacce289e79b6a327d23.svg";
export { ForwardRef as ReactComponent };